import { FoodItem } from "../../../types";
import { motion } from "framer-motion";
import Action from "./action";
export const SingleFoodItem = ({
  item,
  col,
  admin,
  categoryName
}: {
  item: FoodItem;
  col?: boolean;
  admin?:boolean
  /** Display name of the category, resolved by the parent. */
  categoryName?: string
}) => {
  const { title, price, imageURL, description } = item;

  return (
    <motion.div
      whileTap={{ rotate: [0, -1, 1, -1, 0] }}
      className={`${
        !col ? "w-[275px] min-w-[275px]" : "w-[320px] min-w-[320px]"
      } md:w-[300px] md:min-w-[300px] ${
        col ? "my-12" : "my-2 md:my-5"
      } h-auto bg-cardOverlay rounded-lg p-2 px-3 backdrop-blur-lg hover:drop-shadow-sm cursor-pointer`}
    >
      <div className="w-full flex items-center justify-between">
        <motion.img
          whileHover={{ scale: 1.2 }}
          whileTap={{ scale: 1.1 }}
          className="w-40 h-40 md:w-48 md:h-40 -mt-8 object-contain cursor-pointer"
          alt={description}
          src={imageURL}
          loading="lazy"
          decoding="async"
          width={192}
          height={160}
        />
      <Action food={item} admin={admin} />
      </div>
      <div className="w-full flex items-end justify-end flex-col">
        {categoryName && (
          <span
            title={categoryName}
            className="mb-1 max-w-full truncate px-2 py-0.5 rounded-full
              bg-cartNumBg/10 text-cartNumBg text-[10px] font-bold uppercase tracking-wide"
          >
            {categoryName}
          </span>
        )}
        <p className="text-textColor font-semi-bold text-lg">{title}</p>
        <p className="mt-1 text-sm text-gray-500">{description} </p> 
        {!item?.comingSoon && item?.isActive && (
        <div className="flex items-center justify-between gap-8 ">
          <p className="text-base text-headingColor font-semibold">
            <span className="text-sm text-redPrimary">Rs.</span> {price}{item?.unit && ('/'+item?.unit)}
          </p>
        </div>)}
      </div>
    </motion.div>
  );
};
